import { Pipe, PipeTransform } from '@angular/core';
import { FirestoreDocument } from '../../libs/shared/models/firestore-document';

@Pipe({
  name: 'filterBy',
})
export class FilterByPipe implements PipeTransform {
  transform<T, K extends keyof T>(
    items: FirestoreDocument<T>[] | null | undefined,
    keys: K | K[],
    searchTerm?: string
  ): FirestoreDocument<T>[] | null | undefined {
    if (!items || !searchTerm) return items;
    const term = normalizeString(searchTerm);
    return items.filter(({ data }) => {
      const haystack = Array.isArray(keys)
        ? keys
            .map((k) => data?.[k])
            .filter((v) => v != null)
            .map((v) => String(v))
            .join(' ')
        : String(data?.[keys] ?? '');

      return normalizeString(haystack).includes(term);
    });
  }
}

// Case/diacritic-insensitive normalization (e.g., "é" -> "e")
function normalizeString(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
